import type {
  Depot,
  RoutePathCommandResult,
  RoutePathView,
  SaveRoutePathCommand,
  ValidateRoutePathCommand,
} from '@groupe-reca/contracts'

/**
 * Parcours officiel d'une route (onglet « Parcours » de l'éditeur, docs/routes/README.md §13) : lecture de l'état,
 * enregistrement d'un calcul complet, validation. Le serveur revérifie la composition, les étapes et les droits
 * (`route.read` / `route.update`); aucun statut d'intervention n'est touché.
 */
export interface RoutePathRepository {
  /** `season` sert au serveur simulé seulement (la route identifie déjà sa saison en base). */
  getView: (routeId: string, season: string) => Promise<RoutePathView>
  save: (command: SaveRoutePathCommand) => Promise<RoutePathCommandResult>
  validate: (command: ValidateRoutePathCommand) => Promise<RoutePathCommandResult>
  getDepot: () => Promise<Depot | null>
}

export class RoutePathError extends Error {
  readonly code: string

  constructor(code: string) {
    super(code)
    this.name = 'RoutePathError'
    this.code = code
  }
}
